import {PageTemplate} from "../../shared/layout/PageTemplate";
import {CommissionerContent} from "./components/CommissionerContent";

export function Commissioner() {
    return <PageTemplate pageName="Commissioner" title="Enum" content={<CommissionerContent/>}/>
}